import type { ThemePreference } from './preferences'

/**
 * Puts the chosen theme on <html>, where the tokens read it.
 *
 * "Terang" and "Gelap" set data-theme; "Ikuti sistem" removes it and leaves
 * the choice to the prefers-color-scheme query in tokens.css, so a system that
 * switches to dark at sunset takes the app with it without a reload.
 *
 * index.html runs the same logic inline before the first paint; this is the
 * version the app calls when the preference changes.
 */
export function applyTheme(theme: ThemePreference): void {
  const root = document.documentElement
  if (theme === 'system') delete root.dataset.theme
  else root.dataset.theme = theme
}
